// extracted by mini-css-extract-plugin
module.exports =  {"button":"xtjxdNn3gUagtF7ZUCGv","hidden":"QkgXwR8UOCe8cNpwJXQg","input":"jbsQN9YcFx3pxWOYGWpa","select":"U4Qt76Wjcs4FWYONWz2Y","suffix":"BZEKQuFZA_s3p3SSKmrt"};